import banner1 from '@/assets/img/solution/category/banner-1.jpg'
import banner2 from '@/assets/img/solution/category/banner-2.jpg'
import banner3 from '@/assets/img/solution/category/banner-3.jpg'
import banner4 from '@/assets/img/solution/category/banner-4.jpg'
import banner5 from '@/assets/img/solution/category/banner-5.jpg'
import { ProductCategory } from '@/assets/content/products/enum'

interface ProductSolutionDataProps {
  title: string
  subTitle?: string
  description: string
  banner: string
  path?: string
}

export const productSolutionData: ProductSolutionDataProps[] = [
  {
    title: ProductCategory.CommercialEnergyStorageSystems,
    subTitle: 'Maximize Incentives, Minimize Costs — Power Your Business with Smarter Storage',
    description:
      'Up to 50% Federal Tax Credit and 100% SGIP incentives for commercial PV+ESS projects, delivering lower costs, higher returns, and long-term energy',
    banner: banner1,
  },
  {
    title: ProductCategory.ResidentialEnergyStorageSystems,
    subTitle: 'Smart, Safe, and Scalable — Power Your Home with Energy Independence',
    description:
      'Modular batteries with hybrid inverters, advanced liquid cooling, and multi-level safety protection to maximize solar use, provide backup power, and adapt to your family’s changing energy needs.',
    banner: banner2,
  },
  {
    title: ProductCategory.CentralizedPVStorageSystems,
    subTitle: 'From Idle Land to Power Hub — Clean Energy That Works Harder',
    description:
      'Transform underused land into reliable, profitable green energy through optimized PV utilization, microgrid stability, and smart energy management for peak shaving, frequency regulation, and backup power.',
    banner: banner3,
  },
  {
    title: ProductCategory.DistributedPVStorageSystems,
    subTitle: 'Connected, Flexible, and Green — The Future of Urban Energy',
    description:
      'End-to-end solutions integrating PV, BESS, and EV charging with advanced ICT and EMS, optimizing energy allocation, enhancing grid stability, and enabling more communities to share the benefits of clean power while unlocking DSGS incentives.',
    banner: banner4,
  },
  {
    title: ProductCategory.SpecialtyMobilePowerSystems,
    subTitle: 'Power Anywhere, Solutions for Every Challenge',
    description:
      'From hazardous material removal and environmental compliance to construction, waterproofing, and disaster restoration, we deliver mobile, adaptable, and fully compliant power and infrastructure solutions where they’re needed most.',
    banner: banner5,
  },
]
